import { CanActivateFn } from '@angular/router';
import { of } from 'rxjs';

/**
 * Guard that allows all authenticated users into the portal.
 * Users without linked accounts will see empty states.
 * Accounts are linked by admins via the admin system sync.
 */
export const accountGuard: CanActivateFn = () => {
  // All authenticated users can access the portal
  // The authGuard handles authentication check
  // Users without accounts will simply see empty data
  return of(true);
};

// Keep old name for backward compatibility
export const customerGuard = accountGuard;
